import ApiClient from '../../../../base/api';
import { QuickApplyInfoParams, QuickApplyInfoResponse, ValidateStepParams, SubmitQuickApply } from './interfaces';

const apiClient = new ApiClient();

export const quickApplyApi = {
    getQuickApplyInfo: () => apiClient.get<QuickApplyInfoResponse>('/api/vacancies/quick-apply-info'),
    validateQuickApplyInfo: (params: ValidateStepParams) =>
        apiClient.post<ValidateStepParams, void>('/api/vacancies/quick-apply-info', params),
    submitQuickApplyInfo: (params: QuickApplyInfoParams) =>
        apiClient.post<QuickApplyInfoParams, QuickApplyInfoResponse>('/api/vacancies/quick-apply-info', params),
    submitQuickApply: (vacancyId: string, params: SubmitQuickApply) =>
        apiClient.post<SubmitQuickApply, void>(`/api/vacancies/${vacancyId}/quick-apply`, params),
};
